import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { useContext } from 'react'
import { AppContext, AppContextType } from '../AppContext'
import ElectronIPC from '../services/ElectronIPC'
import * as Constants from '../services/Constants'
import { useTranslation } from 'react-i18next'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import { DialogBody, DialogTitle } from '@/components/Dialog'
import { Button } from '@/UIComponents2/Button'

export default function FreeTrialInfoDialogController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const onCloseDialog = () => {
        appDispatch({ type: 'update_app_state', value: { showFreeTrialInfoDialog: false } })
    }

    if (appState.appState.showFreeTrialInfoDialog) {
        return (
            <CrossPlatformDialog frameName={`Dialog:UpgradeToMuseProDialog`} onDefaultClose={onCloseDialog}>
                <FreeTrialInfoDialogContents onClose={onCloseDialog} />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}

const FreeTrialInfoDialogContents = ({ onClose }: { onClose: () => void }) => {
    const { t } = useTranslation()

    const link1 = () => {
        ElectronIPC.openLinkInBrowser(Constants.links.about_boosts_link)
    }
    const link2 = () => {
        ElectronIPC.openLinkInBrowser(Constants.links.muse_pro_plans_link)
    }

    return (
        <div className="w-full">
            <DialogBody>
                <DialogTitle>Welcome to your free trial of Muse Pro!</DialogTitle>

                <div className="mb-2">
                    For two weeks you have access to all features. After your trial, you can{' '}
                    <Button variant="link" onClick={link1}>
                        use boosts
                    </Button>{' '}
                    to temporarily upgrade your session.
                </div>
                <div>
                    <Button variant="link" onClick={link2}>
                        Learn more
                    </Button>{' '}
                    about Muse plans
                </div>
            </DialogBody>

            <DialogActionButtonsSection rightButtonText={t('Close') || 'Close'} onRightButtonClicked={onClose} />
        </div>
    )
}
